import { __awaiter, __generator } from "tslib";
import { call } from './call';
import { IS_APP } from '../constants';
var EVENT_MAP = {
    pageDidAppear: [],
    pageDidDisappear: [],
    pageDeinit: [],
    appWillEnterForeground: [],
    appDidEnterBackground: [],
};
var service = function (params) {
    if (!params)
        return;
    var array = EVENT_MAP[params.type];
    array.forEach(function (fn) {
        try {
            fn();
        }
        catch (_a) { }
    });
};
var isInitRegister = false;
var init = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!IS_APP)
                    return [2 /*return*/];
                return [4 /*yield*/, initPromise];
            case 1:
                _a.sent();
                if (isInitRegister)
                    return [2 /*return*/];
                isInitRegister = true;
                call('SKPage', 'lifeCycle', service);
                return [2 /*return*/];
        }
    });
}); };
var initPromise = new Promise(function (resolve) {
    setTimeout(function () {
        resolve(true);
    }, 1000);
});
export var onLifecycle = function (type, fn) { return __awaiter(void 0, void 0, void 0, function () {
    var array;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, init()];
            case 1:
                _a.sent();
                array = EVENT_MAP[type];
                if (array.includes(fn)) {
                    return [2 /*return*/];
                }
                array.push(fn);
                return [2 /*return*/];
        }
    });
}); };
export var offLifecycle = function (type, fn) {
    var array = EVENT_MAP[type];
    var index = array.indexOf(fn);
    if (index === -1) {
        return;
    }
    array.splice(index, 1);
};
